import { useState, useContext } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import { useMutation } from "@apollo/client";
import { MdDelete, MdModeEdit } from "react-icons/md";
//Import from project
import "../../../Style/actionstyle.scss";
import DialogDelete from "../../../Utils/DialogDelete";
import { AuthContext } from "../../../Context/AuthContext";
import PerformanceForm from "./PerformanceForm";
import { DELETE_PERFORMANCE } from "../../../Schema/Performance";

export default function PerformanceAction({ classId, editData, setRefetch }) {
  const { t, setAlert } = useContext(AuthContext);

  // Edit Modal
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  // Delete Dialog
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const [loading, setLoading] = useState(false);

  // Delete mutation
  const [deletePerformance] = useMutation(DELETE_PERFORMANCE, {
    onCompleted: ({ deletePerformance }) => {
      setLoading(false);
      if (deletePerformance?.isSuccess) {
        setAlert(true, "success", deletePerformance?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deletePerformance?.message);
      }
    },
    onError: (error) => {
      console.error("Delete error:", error?.message);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deletePerformance({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack direction="row" justifyContent="flex-end">
        <Tooltip title={t("update") || "Update"} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title={t("delete") || "Delete"} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      {/* Edit Modal */}
      {openEdit && (
        <PerformanceForm
          open={openEdit}
          classId={classId}
          editData={editData}
          setRefetch={setRefetch}
          dialogTitle="Update"
          handleClose={handleCloseEdit}
        />
      )}

      {/* Delete Confirmation */}
      {openDel && (
        <DialogDelete
          open={openDel}
          loading={loading}
          editData={editData}
          handleClose={handleCloseDel}
          deleteTitle={t("modal_title_delete_performance")}
          handleDelete={handleDelete}
        />
      )}
    </div>
  );
}
